import React from 'react';
import {
    withStyles,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    Grid,
    Typography,
    ButtonBase,
    Snackbar,
    withRouter
} from '../../material-ui';

import FIMUtils from '../../im/FIMUtils'; 
import MBack from '../view/MBack';
import AppUtils from '../../control/apputlis'; 


class FindPwd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phone: '',
            code: '',
            codeTip: '获取验证码',
            snackopened: false,
            message: '',
            password: ''
        }
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'FindPwd'); 
    }

    componentWillUnmount() {
    }

    validatePhone(phone) {
        console.log('validatePhone', phone);
        var re = /^1[3-9]\d{9}$/;
        return re.test(phone);
    }

    _getPhoneCode = async () => {
        if (!this.validatePhone(this.state.phone)) {
            this.setState({ message: '请正确填写手机号码', snackopened: true });
            return;
        }

        let result = await FIMUtils.getCode('86', this.state.phone);
        if (result.ret == 0) {
            this._verifyCodeTimeAction();
        } else {
            this.setState({ message: result.msg, snackopened: true });
        }
    }

    _verifyCodeTimeAction = () => {
        const codeTime = 60;
        this.setState({
            codeTip: codeTime,
        });
        const now = Date.now()
        const overTimeStamp = now + codeTime * 1000 + 100/*过期时间戳（毫秒） +100 毫秒容错*/
        this.interval = setInterval(() => {
            /* 切换到后台不受影响*/
            const nowStamp = Date.now()
            if (nowStamp >= overTimeStamp) {
                /* 倒计时结束*/
                this.interval && clearInterval(this.interval);
                this.setState({
                    codeTip: '获取验证码',
                });
            } else {
                const leftTime = parseInt((overTimeStamp - nowStamp) / 1000, 10)
                this.setState({
                    codeTip: leftTime,

                });
            }
        }, 1000);
    }



    onSubmit = async () => {

        const { phone, code, password } = this.state;
        if (!this.validatePhone(phone)) {
            this.setState({ message: '请正确填写手机号码', snackopened: true });
            return;
        }
        if (code == '' || code.length < 4) {
            this.setState({ message: '请输入验证码', snackopened: true });
            return;
        }
        if (password == '' || password.length < 6) {
            this.setState({ message: '请输入6位数密码', snackopened: true });
            return;
        }
        let result = await FIMUtils.FindPassword(phone, code, password);
        // let result = await Apis.encryptionPhoneCode(phone, code);
        // console.log('encryptionPhoneCode', result);
        if (result.ret == 0) {
            // AppData.me.token = result.data.token;
            // AppData.me.customer_id = result.data.customer_id;
            // this.props.history.replace('/findpwdcfg');
            this.backTimeOut = setTimeout(() => {
                window.history.back();
            }, 1000);
        } else {
            this.setState({ message: result.msg, snackopened: true });
        }
    }

    render() {
        const { classes } = this.props;
        const { phone, code, codeTip, snackopened, message, password } = this.state;
        return (
            <MBack title='找回密码'>
                <Grid style={{ height: 16 }}></Grid>
                <ListItem style={{ backgroundColor: '#fff', height: 50, display: 'flex' }}>
                    <ListItemText primary={
                        <Grid container direction='row' alignItems='center'>
                            <Typography style={{ color: '#0D0D0D', fontSize: 13 }}>手机号</Typography>
                            <input
                                type='tel'
                                className={classes.input}
                                placeholder='输入手机号'
                                onChange={event => this.setState({ phone: event.target.value })}
                                value={phone}
                                maxLength={11} />
                        </Grid>
                    } />

                </ListItem>
                <Grid className={classes.divider}></Grid>
                <ListItem style={{ backgroundColor: '#fff', height: 50, display: 'flex' }}>
                    <ListItemText primary={
                        <Grid container direction='row' alignItems='center'>
                            <Typography style={{ color: '#0D0D0D', fontSize: 13 }}>验证码</Typography>
                            <input
                                type='number'
                                className={classes.input}
                                placeholder='输入验证码'
                                maxLength={6}
                                onChange={event => this.setState({ code: event.target.value })}
                                value={code}
                            />
                        </Grid>
                    } />
                    <ListItemSecondaryAction>
                        <Grid container direction='row' justifyContent='flex-end'>
                            <Typography style={{ color: '#878787', fontSize: 13 }} onClick={() => this._getPhoneCode()} >{codeTip}</Typography>
                        </Grid>
                    </ListItemSecondaryAction>
                </ListItem>
                <Grid className={classes.divider}></Grid>

                <ListItem style={{ backgroundColor: '#fff', height: 50, display: 'flex' }}>
                    <ListItemText primary={
                        <Grid container direction='row' alignItems='center'>
                            <Typography style={{ color: '#0D0D0D', fontSize: 13 }}>新的密码</Typography>
                            <input
                                type='password'
                                className={classes.input}
                                placeholder='输入新的密码'
                                onChange={event => this.setState({ password: event.target.value })}
                                value={password}
                                maxLength={11} />
                        </Grid>
                    } />

                </ListItem>
                <Grid className={classes.divider}></Grid>
                <Grid style={{ height: 25 }}></Grid>
                <Grid container justifyContent='center' >
                    <ButtonBase
                        className={classes.logoutBtn}
                        onClick={() => this.onSubmit()}
                    >确定</ButtonBase>
                </Grid>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackopened}
                    onClose={() => this.setState({ snackopened: false })}
                    message={message}
                    autoHideDuration={3000}>
                </Snackbar>
            </MBack>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    logoutBtn: {
        background: '#007AFF',
        borderRadius: 10,
        color: 'white',
        height: 45,
        width: "80%",
        margin: theme.spacing(5, 0, 2, 0),
        fontSize: 14,
        fontWeight: theme.typography.fontWeightBold,
    },
    divider: {
        height: 1,
        padding: theme.spacing(0, 1.5, 0, 1.5),
        backgroundColor: '#F0F0F0',
    },
    input: {
        outline: 'none',
        border: 0,
        flex: 1,
        marginLeft: 16,
        marginRight: 16,
        fontSize: 14,
    }

}))(FindPwd));